import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Dropdown, Skeleton } from 'antd';

import { AppDispatch } from 'app/store';

import Avatar from 'components/Avatar';

import { selectIsLoading, selectUser } from 'features/auth/authSelectors';
import { logout } from 'features/auth/authSlice';

import { GTMEventLogger } from 'utils/analytics';

import { GTMEvents } from 'constants/enums';
import { ACCESS_PENDING, HOME } from 'constants/path';
import { USER_NAME_LOCAL_STORAGE_KEY } from 'constants/uiSettings';

import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrowDown.svg';

import styles from './LoggedUser.module.scss';

const LoggedUser = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const user = useSelector(selectUser);
  const isLoading = useSelector(selectIsLoading);
  const { t } = useTranslation();

  const { name: userName, attachments } = user;

  const name =
    userName === ''
      ? localStorage.getItem(USER_NAME_LOCAL_STORAGE_KEY) || userName
      : userName;

  const handleLogout = useCallback(() => {
    dispatch(logout());

    if (pathname === ACCESS_PENDING) {
      navigate(HOME);
    }

    GTMEventLogger(GTMEvents.AuthLogout);
  }, [dispatch, navigate, pathname]);

  const menuItems = [
    {
      key: 'logout',
      label: (
        <div className={styles.logoutItem}>{t('common.label.logout')}</div>
      ),
      onClick: handleLogout
    }
  ];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['hover']}
      placement="bottomLeft"
      rootClassName="menu-dropdown-root-container"
    >
      <div className={styles.userContainer}>
        <span className={styles.label}>
          {isLoading ? <Skeleton.Input active size="small" /> : name}
        </span>
        <Avatar name={name} attachments={attachments} />
        <span className={styles.postfix}>
          <ArrowDownIcon />
        </span>
      </div>
    </Dropdown>
  );
};

export default LoggedUser;
